import { ContentItem } from 'kentico-cloud-delivery';
import { get } from 'lodash';

export default class TwoColumnsPanel extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get title() {
    return get(this, '_naglowek.value', '');
  }

  get panels() {
    return get(this, '_panele.value', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/TwoColumnsPanel.model.js